import axios from 'lib/data/axios';
import { useEffect, useState } from 'react';
import { VIEWED_VERTICAL } from '../constants';
import { Complete, PlaylistItem } from '../constants/playEvents';
import { usePlayerEvent } from './usePlayerEvent';

// hook for vertical video playlist - it injects a custom playlist with vertical videos

interface UseVerticalVideoPlaylistProps {
  player: any;
  verticalFloatingMode?: boolean;
  setShowNextVideoPopup: (show: boolean) => void;
  playlistId: string;
}

export default function useVerticalVideoPlaylist({
  player,
  setShowNextVideoPopup,
  verticalFloatingMode,
  playlistId,
}: UseVerticalVideoPlaylistProps) {
  const [customPlaylist, setCustomPlaylist] = useState<PlaylistItem[]>([]);

  const setViewedVerticalSession = () => {
    sessionStorage.setItem(VIEWED_VERTICAL, 'true');
  };

  const verticalVideosPlayed = () => {
    const viewedVideosJson: string | null = sessionStorage.getItem(VIEWED_VERTICAL);

    if (viewedVideosJson === null) {
      return false;
    }
    return true;
  };
  // fetch custom playlist

  const fetchCustomPlaylist = async () => {
    // specific playlist for vertical testing
    const response = await axios<{ playlist: PlaylistItem[] }>(`https://cdn.jwplayer.com/v2/playlists/${playlistId}`);
    if (response?.data) {
      setShowNextVideoPopup(false);
      return response.data.playlist ?? [];
    }
  };

  usePlayerEvent(player, Complete, () => {
    player?.setPlaylistItemCallback(() => {
      return new Promise<PlaylistItem | void>((resolve) => {
        if (customPlaylist.length) {
          setCustomPlaylist((playlist) => playlist.slice(1));
          resolve(customPlaylist[0]);
        } else {
          resolve();
        }
      });
    });
  });

  useEffect(() => {
    if (player && verticalFloatingMode && !verticalVideosPlayed()) {
      fetchCustomPlaylist().then((playlist) => {
        if (playlist?.length) {
          player?.setPlaylistItemCallback(() => {
            return new Promise<PlaylistItem | void>((resolve) => {
              setCustomPlaylist(playlist.slice(1));
              setViewedVerticalSession();
              resolve(playlist[0]);
            });
          });
        }
      });
    }
  }, [player]);
}
